  //-----------------------
  // React basic Components
  //-----------------------
  import React                                               from "react";
  import PropTypes                                           from "prop-types";
//import { NavLink }                                         from "react-router-dom";
  import { connect }                                         from "react-redux";
  //-----------------------------
  // @material-ui/core components
  //-----------------------------
  import withStyles                                          from "@material-ui/core/styles/withStyles";
  import Button                                              from '@material-ui/core/Button';
  import TextField                                           from '@material-ui/core/TextField';
  import CircularProgress                                    from "@material-ui/core/CircularProgress";
//import AccountCircleIcon                                   from "@material-ui/icons/AccountCircle";
  import Dialog                                              from '@material-ui/core/Dialog';
  import DialogActions                                       from '@material-ui/core/DialogActions';
  import DialogContent                                       from '@material-ui/core/DialogContent';
  import DialogContentText                                   from '@material-ui/core/DialogContentText';
  import DialogTitle                                         from '@material-ui/core/DialogTitle';
  import Slide                                               from '@material-ui/core/Slide';
  //[FAB]
  import Fab                                                 from '@material-ui/core/Fab';
  import CallIcon                                            from '@material-ui/icons/Call';
  //[SNACKBAR]
  import Snackbar                                            from '@material-ui/core/Snackbar';
  import MuiAlert                                            from '@material-ui/lab/Alert';
  //------------------
  // Custom components
  //------------------
  import GridContainer                                       from "components/Grid/GridContainer.jsx";
  import GridItem                                            from "components/Grid/GridItem.jsx";
//import CustomInput                                         from "components/CustomInput/CustomInput.jsx";
  import CustomButton                                        from "components/CustomButtons/Button.jsx";
  //----------
  // Libraries
  //----------
  import Cookies                                             from 'js-cookie';
  //recaptcha_V2
  import ReCAPTCHA                                           from "react-google-invisible-recaptcha";
  //recaptcha_V3
//import useRecaptchaV3                                      from "components/useRecaptchaV3/useRecaptchaV3.jsx";
  import { GoogleReCaptchaProvider, GoogleReCaptcha }        from 'react-google-recaptcha-v3';
  //------------
  // WebServices
  //------------
  import { history }                                         from "../../_helpers";
  import { api }                                             from "../../_constants";
  import { wu_StaticDataService }                            from "../../_services";
  import { wu_Utilities }                                    from "../../_services";
  import { wu_TrackTransferService }                         from "../../_services";
  import { wu_GeolocationService }                           from "../../_services";
  //------
  // Style
  //------
  import TrackTransferStyle                                  from "./TrackTransferStyle.jsx";
  //-------
  // images
  //-------
  import logo                                                from "assets/img/wu/WU_CONTENT_main_symbol_left.svg";
  //[Campaign]
  import WU_popup_campaign_el                                from "assets/img/wu/popup_campaign_el.png";
  import WU_popup_campaign_en                                from "assets/img/wu/popup_campaign_en.png";
  //----------
  // variables
  //----------
  const filename = "TrackTransfer ";
  const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
  });
  //[SNACKBAR]
  function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }

  //[Lockers]
  var TrackTransfer_continue_locked = true;

class TrackTransfer extends React.Component {
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Basic Methods-------------------------------------
  //----------------------------------------------------------------------------------------------------
  constructor(props) {
    let methName = filename+"constructor ";
    if(api.print_logs){console.log(methName+props);}

    super(props);
    this.state = {
      dialog_msg                                           : "",
      dialog_isOpen                                        : false,

      viewPleaseWait_hidden                                : true,

      //[SNACKBAR]
      Snackbar_textField_open                              : false,
      Snackbar_textField_msg                               : "",

      //[HONEYMOON]
      textField0                                           : "", //4279034659
      textField0_hasError                                  : false,

      //[RECAPTCHA]
      recaptchaVersionSupported                            : "NONE", //"V2", "V3", "NONE"
      //recaptcha_V3
      refreshReCaptchaV3                                   : false,

      textField1                                           : "", //4279034659
      textField1_hasError                                  : false,
      textField2                                           : "",
      textField2_hasError                                  : false,
      textField3                                           : "",
      textField3_hasError                                  : false,

      //[FAB]
      fab_isHidden                                         : true,
      dialog100_msg                                        : "",
      dialog100_isOpen                                     : false,

      //[Campaign]
      dialog101_msg                                        : "",
      dialog101_isOpen                                     : false,
      dialog101_campaign_image_w                           : "512",
      dialog101_campaign_image_h                           : "268",
    };
    //------------
    //translations
    //------------
    this.texts_gr = wu_StaticDataService.wu_getLocales_gr({});
    this.texts_en = wu_StaticDataService.wu_getLocales_en({});
    //--------
    //bindings
    //--------
    this.verifyGenericItem                                            = this.verifyGenericItem.bind(this);
    this.dialog_handleClose                                           = this.dialog_handleClose.bind(this);
    this.startSpinners                                                = this.startSpinners.bind(this);
    this.stopSpinners                                                 = this.stopSpinners.bind(this);

    //[Lockers]
    this.isLockersActive                                              = this.isLockersActive.bind(this);
    this.startLockers                                                 = this.startLockers.bind(this);
    this.stopLockers                                                  = this.stopLockers.bind(this);

    //[SNACKBAR]
    this.Snackbar_textField_handleOpen                                = this.Snackbar_textField_handleOpen.bind(this);
    this.Snackbar_textField_handleClose                               = this.Snackbar_textField_handleClose.bind(this);

    this.handleSubmit                                                 = this.handleSubmit.bind(this);
    this.handleSubmit_isDisabled                                      = this.handleSubmit_isDisabled.bind(this);
    this.handleSubmit_with_enter                                      = this.handleSubmit_with_enter.bind(this);
    //recaptcha_V2
    this.handleSubmit_with_recaptcha                                  = this.handleSubmit_with_recaptcha.bind(this);
    this.recaptchaRef                                                 = React.createRef();
    //recaptcha_V3
    this.handleSubmit_get_recaptchaV3_token                           = this.handleSubmit_get_recaptchaV3_token.bind(this);
    this.handleSubmit_reset_recaptchaV3_token                         = this.handleSubmit_reset_recaptchaV3_token.bind(this);

    //[FAB]
    this.fab_geoLocateIP                                              = this.fab_geoLocateIP.bind(this);
    this.fab_Click2CallAction                                         = this.fab_Click2CallAction.bind(this);
    this.dialog100_handleOpen                                         = this.dialog100_handleOpen.bind(this);
    this.dialog100_handleClose                                        = this.dialog100_handleClose.bind(this);

    //[CAMPAIGN]
    this.dialog101_handleOpen                                         = this.dialog101_handleOpen.bind(this);
    this.dialog101_handleClose                                        = this.dialog101_handleClose.bind(this);
  }
  //----------------------------------------------------------------------------------------------------
  componentWillMount() {
    let methName = filename+"componentWillMount ";
    if(api.print_logs){console.log(methName);}

    localStorage.setItem("prev_view", localStorage.getItem("curr_view"));
    localStorage.setItem("curr_view", filename);
    console.log(Cookies.get('curr_view',{secure:false,expires:1,path:api.webapp_path}));
    Cookies.set('curr_view', filename.trim());

    if(localStorage.getItem("lang")!=='el' && localStorage.getItem("lang")!=='en'){ localStorage.setItem("lang","el"); }

    if(wu_Utilities.checkIfUserIsLoggedIn()){
      wu_Utilities.update_uilatstats();
      if(!wu_Utilities.check_uilatstats(api.uilatstats_inactivity_mins)){
        wu_Utilities.LogoutUserFromApp(filename);
        history.push(wu_Utilities.getNavigationURLs("LoginPage"));
        return;
      }
    }

    //[Lockers]
    this.stopLockers();

    //-------------
    //Do some reset
    //-------------
    try { localStorage.setItem("parserObject_omtregistrationTriggerOTP_req", ""); } catch(err){;}
    try { localStorage.setItem("parserObject_transhistorydetail_unique",""); } catch(err){;}
    try { localStorage.setItem("LoginPage_flow",          "false"); } catch(err){;}
    try { localStorage.setItem("TransferOnlineLogin_flow","false"); } catch(err){;}
    try { localStorage.setItem("RegisterLight1".trim(), "");  } catch(err){;}
    try { localStorage.setItem("CustomerWantedToLoginToBills", "false"); } catch(err){;}

    //[FAB]
    this.fab_geoLocateIP();

    //[CAMPAIGN]
    //wu_Utilities.campaign_clear_statsView(api.campaign_enabled,api.campaign_prefix,api.campaign_cap_per_session,filename.trim());
    wu_Utilities.campaign_record_load(api.campaign_enabled,api.campaign_prefix,api.campaign_cap_per_session,api.campaign_startDate,api.campaign_endDate,filename.trim());
    if(wu_Utilities.campaign_should_show(api.campaign_enabled,api.campaign_prefix,api.campaign_cap_per_session,api.campaign_startDate,api.campaign_endDate,filename.trim())===true){
      console.log("campaigns window.innerWidth="+window.innerWidth);
      if(window.innerWidth > 960){ this.setState({"dialog101_campaign_image_w":"512","dialog101_campaign_image_h":"268",}); }
      else                       { this.setState({"dialog101_campaign_image_w":"256","dialog101_campaign_image_h":"134",}); }
      this.dialog101_handleOpen("");
    }
  }
  //----------------------------------------------------------------------------------------------------
  //[FAB]
  fab_geoLocateIP(){
    let methName = "fab_geoLocateIP";
    //SOS TODO cache for a certain period
    if(localStorage.getItem("IPCOUNTRY")!==""){ this.setState({ "fab_isHidden":false }); return; }
    //-------------------
    //wu_getPhonePrefixes---STATIC
    //-------------------
    let phonePrefixes = wu_StaticDataService.wu_getPhonePrefixes({});
    //--------------
    //wu_geolocation
    //--------------
    wu_GeolocationService
    .wu_geolocation({}) //FAB
    .then(res => {
      if(localStorage.getItem("curr_view").trim()!=="TrackTransfer"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
      localStorage.setItem("parserObject_geolocation",JSON.stringify(res.location));
      let ws_country = "";
      try {ws_country = res.location["country"]; }catch(err){;} if(ws_country === null || (typeof ws_country ==="undefined")){ws_country = "";}
      for(let i=0; i<phonePrefixes.phone_prefixes.length; ++i){
        if(phonePrefixes.phone_prefixes[i]["descr"].indexOf(ws_country)>=0){
          localStorage.setItem("IPCOUNTRY",           phonePrefixes.phone_prefixes[i]["ctry_wu_id"]);
          localStorage.setItem("UserSelectedCountry", phonePrefixes.phone_prefixes[i]["ctry_wu_id"]);
          break;
        }
      }
      //console.log(methName+"IPCOUNTRY="+localStorage.getItem("IPCOUNTRY"));
      if(localStorage.getItem("IPCOUNTRY")!==""){this.setState({ "fab_isHidden":false });}
    })
    .catch(err => {
      console.log(methName+"err="+err);
    });
  }
  //----------------------------------------------------------------------------------------------------
  componentDidMount() {
    let methName = filename+"componentDidMount ";
    if(api.print_logs){console.log(methName);}

    //nailed for testing:START---inactive
    //this.setState({ ["textField1"]      : "4279034659" });
    //this.setState({ ["textField1State"] : "success" });
    //this.setState({ ["textField2"]      : "MARIA" });
    //this.setState({ ["textField2State"] : "success" });
    //this.setState({ ["textField3"]      : "PAPA" });
    //this.setState({ ["textField3State"] : "success" });
    //nailed for testing:END

    //----------------------
    //Criteo Event Recording
    //----------------------
    let shouldUseCriteo = api.shouldUseCriteo;
    if(shouldUseCriteo===true && api.webappENV==="PROD"){
      try {
        window.criteo_q = window.criteo_q || [];
        var deviceType = /iPad/.test(navigator.userAgent) ? "t" : /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Silk/.test(navigator.userAgent) ? "m" : "d";
        window.criteo_q.push(
         { event: "setAccount", account: api.criteo_account }, // You should never update this line
         { event: "setEmail", email: "" },                  // Can be an empty string
         { event: "setSiteType", type: deviceType},
         { event: "trackTransaction", id: Math.floor(Math.random()*99999999999)+1, item: [{id:"1", price:1, quantity:1}] }
        );
      }catch(err0){console.log(methName+"err0="+err0);}
    }
  }
  //----------------------------------------------------------------------------------------------------
  componentWillUnmount() {
    let methName = filename+"componentWillUnmount ";
    if(api.print_logs){console.log(methName);}
  }
  //----------------------------------------------------------------------------------------------------
  render() {
    let methName = filename+"render ";
    if(api.print_logs){console.log(methName);}

    const classes = this.props.classes;

    return (
      <div className={classes.container}>
        <GridContainer justify="center">
          {/* [FAB] */}
          {this.state.fab_isHidden === true ? ( "" ) : (
            <Fab color="primary" aria-label="add" onClick={this.fab_Click2CallAction} className={classes.fab}>
              <CallIcon />
            </Fab>
          )}
          <GridItem xs={12} sm={6} md={6}>

            <div style={{ marginTop: 25 }}>
              <div className={classes.labelHeader}>{this.NSInforString("TrackTransfer_title")}</div>
              <div className={classes.logo}><img src={logo} alt="logo" /></div>
            </div>

            <GridContainer justify="center">
              <GridItem xs={12} sm={12} md={12}>
                <div className={classes.TrackTransfer_lbl1}>{this.NSInforString("TrackTransfer_lbl1")}</div>
              </GridItem>

              {/* ------------------------- */}
              {/* ----------[HONEYMOON]---- */}
              {/* ------------------------- */}
              <GridItem xs={12} sm={12} md={12} className={classes.GridItemTextField0}>
                  <TextField
                    fullWidth
                    autoComplete={this.autoCompleteText_Textfields()}
                    error={this.state.textField0_hasError}
                    className={classes.textField0}
                    id={this.autoCompleteText_Textfields()}
                    label={this.autoCompleteText_Textfields()}
                    value={this.state.textField0}
                    InputProps={{ fullWidth: true, onChange: event => this.change(event, "textField0"), type: "text" }}
                  />
              </GridItem>

              <GridItem xs={12} sm={12} md={12}>
                  <TextField
                    fullWidth
                    error={this.state.textField1_hasError}
                    className={classes.textField1}
                    id="textField1"
                    label={this.NSInforString("TrackTransfer_plh1")}
                    value={this.state.textField1}
                    InputProps={{ fullWidth: true, onChange: event => this.change(event, "textField1"), type: "text" }}
                  />
              </GridItem>

              {/* <GridItem xs={12} sm={12} md={12}>
                  <TextField
                    fullWidth
                    error={this.state.textField2_hasError}
                    className={classes.textField2}
                    id="textField2"
                    label={this.NSInforString("TrackTransfer_plh2")}
                    value={this.state.textField2}
                    InputProps={{
                      fullWidth: true,
                      onChange: event => this.change(event, "textField2"),
                      type: "text"
                    }}
                  />
              </GridItem>

              <GridItem xs={12} sm={12} md={12}>
                  <TextField
                    fullWidth
                    onKeyPress={this.handleSubmit_with_enter}
                    error={this.state.textField3_hasError}
                    className={classes.textField3}
                    id="textField3"
                    label={this.NSInforString("TrackTransfer_plh3")}
                    value={this.state.textField3}
                    InputProps={{
                      fullWidth: true,
                      onChange: event => this.change(event, "textField3"),
                      type: "text"
                    }}
                  />
              </GridItem> */}
              {/* ------------------------- */}
              {/* ----------[SPINNERS]----- */}
              {/* ------------------------- */}
              {this.state.viewPleaseWait_hidden === true ? ( "" ) : (
                <GridContainer justify="center">
                  <GridItem xs={3} sm={3} md={3}></GridItem>
                  <GridItem xs={6} sm={6} md={6}>
                    <div className={classes.pleaseWait}><CircularProgress/><span>&nbsp;{this.NSInforString("please_wait")}</span></div>
                  </GridItem>
                  <GridItem xs={3} sm={3} md={3}></GridItem>
                </GridContainer>
              )}
              {/* ------------------------- */}
              {/* ----------[BUTTONS]------ */}
              {/* ------------------------- */}
              <GridContainer justify="center">
              <GridItem xs={10} sm={10} md={10}>
                {/* -----------recaptcha_NONE -------------- */}
                {this.state.recaptchaVersionSupported === "NONE" ? (
                  <div className={classes.textCenter}>
                    <CustomButton
                      disabled={this.handleSubmit_isDisabled()}
                      className={classes.yellowButton}
                      color="rose"
                      onClick={this.handleSubmit}
                      type="submit">
                      {this.NSInforString("TrackTransfer_btn_track")}
                    </CustomButton>
                  </div>
                ) : ( "" )}
                {/* -----------recaptcha_V2 -------------- */}
                {this.state.recaptchaVersionSupported === "V2" ? (
                  <div className={classes.textCenter}>
                    <ReCAPTCHA
                      ref={ ref => this.recaptchaRef = ref }
                      locale={localStorage.getItem("lang")}
                      sitekey={api.captchKey}
                      onResolved={this.handleSubmit} />
                    <CustomButton
                      disabled={this.handleSubmit_isDisabled()}
                      className={classes.yellowButton}
                      color="rose"
                      onClick={this.handleSubmit_with_recaptcha}
                      type="submit">
                      {this.NSInforString("TrackTransfer_btn_track")}
                    </CustomButton>
                  </div>
                ) : ( "" )}
                {/* -----------recaptcha_V3 -------------- */}
                {this.state.recaptchaVersionSupported === "V3" ? (
                  <div className={classes.textCenter}>
                    <GoogleReCaptchaProvider reCaptchaKey={api.captchKeyV3}>
                      <GoogleReCaptcha
                          className="google-recaptcha-custom-class"
                          onVerify={this.handleSubmit_get_recaptchaV3_token}
                          refreshReCaptcha={this.state.refreshReCaptchaV3}
                      />
                    </GoogleReCaptchaProvider>
                    <CustomButton
                      disabled={this.handleSubmit_isDisabled()}
                      className={classes.yellowButton}
                      color="rose"
                      onClick={this.handleSubmit}
                      type="submit">
                      {this.NSInforString("TrackTransfer_btn_track")}
                    </CustomButton>
                  </div>
                ) : ( "" )}
              </GridItem>
              </GridContainer>
              {/* -------------------------------------------------- */}
              {/* ----------[goBack Bottom]------------------------- */}
              {/* -------------------------------------------------- */}
              {api.backButtonAtBottom === true ? (
                <GridContainer justify="center">
                  <GridItem xs={10} sm={10} md={10}>
                    <div className={classes.textCenter}>
                      <CustomButton
                        disabled={false}
                        className={classes.backButton}
                        color="rose"
                        onClick={this.goBack}>
                        {this.NSInforString("BillsHistoryDetail_btn_prev")}
                      </CustomButton>
                    </div>
                  </GridItem>
                </GridContainer>
              ) : ( "" ) }
            </GridContainer>

          </GridItem>
        </GridContainer>
        {/* ------------------------- */}
        {/* ----------[SNACKBAR]----- */}
        {/* ------------------------- */}
        <Snackbar open={this.state.Snackbar_textField_open} autoHideDuration={api.snackBarDurationMS} onClose={this.Snackbar_textField_handleClose}>
          <Alert onClose={this.Snackbar_textField_handleClose} severity="error">{this.state.Snackbar_textField_msg}</Alert>
        </Snackbar>
        {/* ------------------------- */}
        {/* ----------[POPUP]-------- */}
        {/* ------------------------- */}
        <div>
          <Dialog
            open={this.state.dialog_isOpen}
            TransitionComponent={Transition}
            keepMounted
            onClose={this.dialog_handleClose}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
          >
            <DialogTitle id="alert-dialog-slide-title">{api.popup_tile}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-slide-description">{this.state.dialog_msg}</DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button className={classes.popupOkButton} color="default" onClick={this.dialog_handleClose}>OK</Button>
            </DialogActions>
          </Dialog>
        </div>
        {/* ------------------------- */}
        {/* ----------[POPUP][FAB]--- */}
        {/* ------------------------- */}
        <div>
          <Dialog
            open={this.state.dialog100_isOpen}
            TransitionComponent={Transition}
            keepMounted
            onClose={this.dialog100_handleClose}
            aria-labelledby="alert-dialog100-slide-title"
            aria-describedby="alert-dialog100-slide-description"
          >
            <DialogTitle id="alert-dialog100-slide-title">{api.popup_tile}</DialogTitle>
            {localStorage.getItem("lang")==="en" ? (
              <DialogContent>Need assistance?<br/>We are at your disposal!<br/>Call us at<br/><b><a href="tel://2109005000">210 900 5000</a></b><br/>or<br/><b><a href="tel://8001002020">800 100 2020</a></b><br/>(toll free from a landline)<br/><br/>Call Center operating hours:<br/>Monday to Sunday 08:00 με 21:00</DialogContent>
            ) : (
              <DialogContent>Χρειάζεσαι βοήθεια;<br/>Είμαστε στη διάθεσή σου!<br/>Κάλεσε μας στο<br/><b><a href="tel://2109005000">210 900 5000</a></b><br/>ή στο<br/><b><a href="tel://8001002020">800 100 2020</a></b><br/>(χωρίς χρέωση από σταθερό)<br/><br/>Ωράριο τηλεφωνικής εξυπηρέτησης:<br/>Δευτέρα με Κυριακή 08:00 με 21:00</DialogContent>
            )}
            <DialogActions>
              <Button className={classes.popupOkButton} color="default" onClick={this.dialog100_handleClose}>OK</Button>
            </DialogActions>
          </Dialog>
        </div>
        {/* ------------------------------ */}
        {/* ----------[POPUP][CAMPAIGN]--- */}
        {/* ------------------------------ */}
        <div>
          <Dialog
            open={this.state.dialog101_isOpen}
            TransitionComponent={Transition}
            keepMounted
            onClose={this.dialog101_handleClose}
            aria-labelledby="alert-dialog101-slide-title"
            aria-describedby="alert-dialog101-slide-description"
          >
            <DialogTitle id="alert-dialog101-slide-title">{api.popup_tile}</DialogTitle>
            {localStorage.getItem("lang")==="el" ? (
              <DialogContent><img src={WU_popup_campaign_el} alt=""  width={this.state.dialog101_campaign_image_w} height={this.state.dialog101_campaign_image_h}/></DialogContent>
            ) : (
              <DialogContent><img src={WU_popup_campaign_en} alt=""  width={this.state.dialog101_campaign_image_w} height={this.state.dialog101_campaign_image_h}/></DialogContent>
            )}
            <DialogActions>
              <Button className={classes.popupOkButton} color="default" onClick={this.dialog101_handleClose}>OK</Button>
            </DialogActions>
          </Dialog>
        </div>
      </div>
    );
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Drop Down Listeners-------------------------------
  //----------------------------------------------------------------------------------------------------
  //...
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Button Listeners----------------------------------
  //----------------------------------------------------------------------------------------------------
  //recaptcha_V3
  generateRecaptchaV3() {
    let methName = filename+"generateRecaptchaV3 ";
    //if(api.print_logs){console.log(methName);}

    if(this.state.recaptchaVersionSupported==="V3"){
      window.grecaptcha.execute(api.captchKeyV3, {action: "YOUR_ACTION_NAME"}).then(function(token) {
        if (token) {
          if(api.print_logs){console.log(methName+"token="+token);}
          localStorage.setItem("recaptchaTokenV3", token);
        }
      });
    }
  }
  //----------------------------------------------------------------------------------------------------
  handleSubmit_isDisabled(){
    if(this.isLockersActive()===true){ return true; }
    return false;
  }
  handleSubmit_with_enter(event){
    if (event.charCode === 13) { // enter key pressed
      event.preventDefault();
      this.handleSubmit(event);
      // do something here
    }
  }
  //----------------------------------------------------------------------------------------------------
  handleSubmit_with_recaptcha(event) {
    let methName = filename+"handleSubmit_with_recaptcha ";
    if(api.print_logs){console.log(methName);}

    let shouldResetCaptcha = (this.state.recaptchaVersionSupported==="V2") ? true : false; //true;//api.isCaptchaEnabled;

    //+++++++++++++++++++++++
    //validate Only Emptyness
    //+++++++++++++++++++++++
    let validateOnlyEmptyness = true;
    if(validateOnlyEmptyness){
      let emptyFields = false;
      if(this.state.textField1.trim() === "") { this.setState({"textField1_hasError" : true }); emptyFields = true; }
    //if(this.state.textField2.trim() === "") { this.setState({"textField2_hasError" : true }); emptyFields = true; }
    //if(this.state.textField3.trim() === "") { this.setState({"textField3_hasError" : true }); emptyFields = true; }
      if(emptyFields===true){if(shouldResetCaptcha){this.recaptchaRef.reset();}this.handleSubmit_reset_recaptchaV3_token("validation");return;}
    }
    //+++++++++++++
    //validate Data
    //+++++++++++++
    if(this.verifyGenericItem("MTCN",      this.state.textField1)===false){
      this.setState({"textField1_hasError" : true });
      this.dialog_handleOpen(this.NSInforString("common.mtcn.digits"));
      if(shouldResetCaptcha){this.recaptchaRef.reset();}this.handleSubmit_reset_recaptchaV3_token("validation");
      return;
    }
    /*if(this.verifyGenericItem("firstName", this.state.textField2.replace(/ /g,""))===false){
      this.setState({"textField2_hasError" : true });
      this.dialog_handleOpen(this.NSInforString("common.firstName.size"));
      if(shouldResetCaptcha){this.recaptchaRef.reset();}this.handleSubmit_reset_recaptchaV3_token("validation");
      return;
    }
    if(this.verifyGenericItem("lastName",  this.state.textField3.replace(/ /g,""))===false){
      this.setState({"textField3_hasError" : true });
      this.dialog_handleOpen(this.NSInforString("common.lastName.size"));
      if(shouldResetCaptcha){this.recaptchaRef.reset();}this.handleSubmit_reset_recaptchaV3_token("validation");
      return;
    }*/
    //++++++++++++++++++++
    //validate [HONEYMOON]
    //++++++++++++++++++++
    if(this.state.textField0.trim()!==""){
      //this.setState({"textField1_hasError" : true });
      if(api.show_error_generic_input){this.dialog_handleOpen(this.NSInforString("error_generic_input"));}
      if(shouldResetCaptcha){this.recaptchaRef.reset();}this.handleSubmit_reset_recaptchaV3_token("validation");
      return;
    }
    //++++++++
    //Continue
    //++++++++
    event.preventDefault();
    if(this.handleSubmit_isDisabled()){ console.log(methName+"reset");  this.recaptchaRef.reset();   }
    else                              { console.log(methName+"execute");this.recaptchaRef.execute(); }
  }
  //----------------------------------------------------------------------------------------------------
  //recaptcha_V3
  async handleSubmit_get_recaptchaV3_token(token) {
    let methName = filename+"handleSubmit_get_recaptchaV3_token ";
    //if(api.print_logs){console.log(methName);}

    if (token && token.length>300) {
      if(api.print_logs){console.log(methName+"token="+token);}
      localStorage.setItem("recaptchaTokenV3", token);
    }
  }
  //recaptcha_V3
  //----------------------------------------------------------------------------------------------------
  handleSubmit_reset_recaptchaV3_token(status) {
    let methName = filename+"handleSubmit_reset_recaptchaV3_token ";
    //if(api.print_logs){console.log(methName);}

    if(this.state.recaptchaVersionSupported==="V3"){
      if(status==="success"){ this.setState({"refreshReCaptchaV3" : !this.state.refreshReCaptchaV3 }); this.generateRecaptchaV3(); return; }
      if(status==="failure"){ this.setState({"refreshReCaptchaV3" : !this.state.refreshReCaptchaV3 }); this.generateRecaptchaV3(); return; }
      if(api.print_logs){console.log(methName+"this.state.refreshReCaptchaV3="+this.state.refreshReCaptchaV3);}
    }
  }
  //----------------------------------------------------------------------------------------------------
  async handleSubmit(event) {
    let methName = filename+"handleSubmit ";
    if(api.print_logs){console.log(methName);}

    event.preventDefault();

    //[Lockers]
    if( this.isLockersActive() ){ return; }
    else                        { this.startLockers(); }

    let shouldResetCaptcha = (this.state.recaptchaVersionSupported==="V2") ? true : false; //true;//api.isCaptchaEnabled;
    //+++++++++++
    //[RECAPTCHA]
    //+++++++++++
    var recaptchaVerify = "";
    //recaptcha_V2
    if(this.state.recaptchaVersionSupported==="V2"){
      recaptchaVerify = api.isCaptchaEnabled ? JSON.stringify(this.recaptchaRef.getResponse()) : "";
      if(api.print_logs){console.log(methName+"recaptchaVerify="+recaptchaVerify);}
    }
    //recaptcha_V3
    if(this.state.recaptchaVersionSupported==="V3"){
      recaptchaVerify = localStorage.getItem("recaptchaTokenV3");
      if(api.print_logs){console.log(methName+"recaptchaVerify="+recaptchaVerify);}
    }

    //++++++++++++++++++++++
    //webapp session timeout
    //++++++++++++++++++++++
    if(wu_Utilities.checkIfUserIsLoggedIn()){
      wu_Utilities.update_uilatstats();
      if(!wu_Utilities.check_uilatstats(api.uilatstats_inactivity_mins)){ wu_Utilities.LogoutUserFromApp(filename); history.push(wu_Utilities.getNavigationURLs("LoginPage")); return; }
    }
    //+++++++++++++++++++++++
    //validate Only Emptyness
    //+++++++++++++++++++++++
    let validateOnlyEmptyness = true;
    if(validateOnlyEmptyness){
      let emptyFields = false;
      if(this.state.textField1.trim() === "") { this.setState({"textField1_hasError" : true }); emptyFields = true; }
    //if(this.state.textField2.trim() === "") { this.setState({"textField2_hasError" : true }); emptyFields = true; }
    //if(this.state.textField3.trim() === "") { this.setState({"textField3_hasError" : true }); emptyFields = true; }
      if(emptyFields===true){this.stopLockers();if(shouldResetCaptcha){this.recaptchaRef.reset();}this.handleSubmit_reset_recaptchaV3_token("validation");return;}
    }
    //+++++++++++++
    //validate Data
    //+++++++++++++
    if(this.verifyGenericItem("MTCN",      this.state.textField1)===false){
      this.setState({"textField1_hasError" : true });
      this.dialog_handleOpen(this.NSInforString("common.mtcn.digits"));
      if(shouldResetCaptcha){this.recaptchaRef.reset();}this.handleSubmit_reset_recaptchaV3_token("validation");
      this.stopLockers(); return;
    }
    /*if(this.verifyGenericItem("firstName", this.state.textField2.replace(/ /g,""))===false){
      this.setState({"textField2_hasError" : true });
      this.dialog_handleOpen(this.NSInforString("common.firstName.size"));
      if(shouldResetCaptcha){this.recaptchaRef.reset();}this.handleSubmit_reset_recaptchaV3_token("validation");
      this.stopLockers(); return;
    }
    if(this.verifyGenericItem("lastName",  this.state.textField3.replace(/ /g,""))===false){
      this.setState({"textField3_hasError" : true });
      this.dialog_handleOpen(this.NSInforString("common.lastName.size"));
      if(shouldResetCaptcha){this.recaptchaRef.reset();}this.handleSubmit_reset_recaptchaV3_token("validation");
      this.stopLockers(); return;
    }*/
    //++++++++++++++++++++
    //validate [HONEYMOON]
    //++++++++++++++++++++
    if(this.state.textField0.trim()!==""){
      //this.setState({"textField1_hasError" : true });
      if(api.show_error_generic_input){this.dialog_handleOpen(this.NSInforString("error_generic_input"));}
      if(shouldResetCaptcha){this.recaptchaRef.reset();}this.handleSubmit_reset_recaptchaV3_token("validation");
      this.stopLockers(); return;
    }
    //++++++++
    //Continue
    //++++++++
    //event.preventDefault();
    this.startSpinners();
    setTimeout(function() { //Start the timer
      //----------------
      //wu_tracktransfer
      //----------------
      wu_TrackTransferService
      .wu_tracktransfer({codeno:this.state.textField1,senderFirstName:this.state.textField2,senderLastName:this.state.textField3,recaptchaVerify:recaptchaVerify})
      .then(res => {
        if(localStorage.getItem("curr_view").trim()!=="TrackTransfer"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
        if(shouldResetCaptcha){this.recaptchaRef.reset();}this.handleSubmit_reset_recaptchaV3_token("success");
        this.stopLockers();this.stopSpinners();
        if(res.returnCode===0){
          this.dialog_handleOpen(res.returnText);
        }
      })
      .catch(err => {
        if(shouldResetCaptcha){this.recaptchaRef.reset();}this.handleSubmit_reset_recaptchaV3_token("failure");
        this.stopLockers();this.stopSpinners();
        console.log(methName+"err="+JSON.stringify(err));
        if(err && err.returnCode && err.returnCode!==0){ this.dialog_handleOpen(err.returnText); }
        else                                           { this.dialog_handleOpen(this.NSInforString("networkerror")); }
      });
    }.bind(this), 500);
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------[goBack]------------------------------------------
  //----------------------------------------------------------------------------------------------------
  goBack(event) {

    //history.go(-1);
    history.goBack();
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------TextField Listeners-------------------------------
  //----------------------------------------------------------------------------------------------------
  change(event, stateVar) {
    let eventTMP = event.target.value+"";
    //if(api.print_logs){console.log(stateVar+" "+eventTMP);}

    if(api.allow_hp_to_be_edited===true && stateVar==="textField0"){ //[HONEYMOON]
      this.setState({"textField0":eventTMP.trim(),});
    }
    else if(stateVar==="textField1"){
      //eventTMP = eventTMP.toUpperCase();
      this.setState({
        "textField1"          : eventTMP,
        "textField1_hasError" : (eventTMP.trim() === "") ? true : false,
      });
      if(eventTMP.length>0 && wu_Utilities.offline_validate_numericCharacters(eventTMP.replace(/ /g,""))===false){ this.Snackbar_textField_handleOpen(this.NSInforString("common.field.digits")); this.setState({"textField1_hasError":true}); return; }
    }
    else if(stateVar==="textField2"){
      eventTMP = eventTMP.toUpperCase();
      this.setState({
        "textField2"          : eventTMP,
        "textField2_hasError" : (eventTMP.trim() === "") ? true : false,
      });
      if(eventTMP.length>0 && wu_Utilities.offline_validate_latinCharacters(eventTMP.replace(/ /g,""))===false){ this.Snackbar_textField_handleOpen(this.NSInforString("common.field.latin")); this.setState({"textField2_hasError":true}); return; }
    }
    else if(stateVar==="textField3"){
      eventTMP = eventTMP.toUpperCase();
      this.setState({
        "textField3"          : eventTMP,
        "textField3_hasError" : (eventTMP.trim() === "") ? true : false,
      });
      if(eventTMP.length>0 && wu_Utilities.offline_validate_latinCharacters(eventTMP.replace(/ /g,""))===false){ this.Snackbar_textField_handleOpen(this.NSInforString("common.field.latin")); this.setState({"textField3_hasError":true}); return; }
    }
    else{
      this.setState({ [stateVar] : eventTMP });
    }
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Utilities-----------------------------------------
  //----------------------------------------------------------------------------------------------------
  NSInforString = aKey => {
    if(localStorage.getItem("lang")==="en"){ return this.texts_en[aKey] ? this.texts_en[aKey] : ""; }
    else                                   { return this.texts_gr[aKey] ? this.texts_gr[aKey] : ""; }
  };
  //----------------------------------------------------------------------------------------------------
  verifyLength(value, length) {
    if (value && value.length >= length) { return true; }
    return false;
  }
  //----------------------------------------------------------------------------------------------------
  verifyGenericItem(key,val) {
    if(key==="MTCN")                             { return wu_Utilities.wu_verifyMTCN(val);  }
    if(key==="firstName")                        { return wu_Utilities.offline_validate_firstName(val); }
    if(key==="lastName")                         { return wu_Utilities.offline_validate_lastName(val);  }

    return false;
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Popups--------------------------------------------
  //----------------------------------------------------------------------------------------------------
  dialog_handleOpen(dialog_msg){
    this.setState({
      "dialog_isOpen" : true,
      "dialog_msg"    : dialog_msg
    });
  }
  dialog_handleClose(){
    this.setState({ "dialog_isOpen": false });
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------[SNACKBAR]----------------------------------------
  //----------------------------------------------------------------------------------------------------
  Snackbar_textField_handleOpen(msg){
    this.setState({
      "Snackbar_textField_open" : true,
      "Snackbar_textField_msg"  : msg,
    });
  }
  Snackbar_textField_handleClose(){
    this.setState({ "Snackbar_textField_open" : false });
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Spinners------------------------------------------
  //----------------------------------------------------------------------------------------------------
  startSpinners(){
    this.setState({ "viewPleaseWait_hidden" : false });
  }
  //----------------------------------------------------------------------------------------------------
  stopSpinners(){
    this.setState({ "viewPleaseWait_hidden" : true });
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------[Lockers]-----------------------------------------
  //----------------------------------------------------------------------------------------------------
  isLockersActive(){
    if( TrackTransfer_continue_locked===true ){ return true;  }
    else                                      { return false; }
    //if( localStorage.getItem(filename.trim()+"_continue_locked")==="true" ){ /*console.log("isLockersActive===true");*/  return true;  }
    //else                                                                   { /*console.log("isLockersActive===false");*/ return false; }
  }
  //----------------------------------------------------------------------------------------------------
  startLockers(){
    TrackTransfer_continue_locked = true;
  }
  //----------------------------------------------------------------------------------------------------
  stopLockers(){
    TrackTransfer_continue_locked = false;
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------[FAB]---------------------------------------------
  //----------------------------------------------------------------------------------------------------
  fab_Click2CallAction(){
    if(localStorage.getItem("IPCOUNTRY")!==""){ this.dialog100_handleOpen(""); }
    else                                      { window.open(api.helpdeskURL, "Live Support", "toolbar=0,status=0,width=548,height=325"); }
  }
  dialog100_handleOpen(dialog_msg){
    this.setState({ "dialog100_isOpen" : true });
    this.setState({ "dialog100_msg"    : dialog_msg });
  }
  dialog100_handleClose(){
    this.setState({ "dialog100_isOpen": false });
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------[CAMPAIGN]----------------------------------------
  //----------------------------------------------------------------------------------------------------
  dialog101_handleOpen(dialog_msg){
    this.setState({ "dialog101_isOpen" : true });
    this.setState({ "dialog101_msg"    : dialog_msg });
  }
  dialog101_handleClose(){
    this.setState({ "dialog101_isOpen": false });
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Autocomplete--------------------------------------
  //----------------------------------------------------------------------------------------------------
  autoCompleteText_autoCompleteDropDown(){
    return filename+Math.random().toString().replace(/0\./g,"");
  }
  //----------------------------------------------------------------------------------------------------
  autoCompleteText_Textfields(){
    //return filename+Math.random().toString().replace(/0\./g,"");
    //return filename.replace(/ /g,"")+Math.random().toString().replace(/0\./g,"");
    return Math.random().toString().replace(/0\./g,"")+"TT1"+Math.random().toString().replace(/0\./g,"");
  }
  //----------------------------------------------------------------------------------------------------
}
TrackTransfer.propTypes = {
  classes: PropTypes.object.isRequired
};
function mapStateToProps(state) {
  const { alert }    = state;
  const { dispatch } = state;
  return {
    dispatch,
    alert
  };
}
export default connect(mapStateToProps)(
  withStyles(TrackTransferStyle)(TrackTransfer)
);
